import moment, { MomentInput } from "moment";

export function formatDate(date?: MomentInput): string | null {
    if (!date) {
        return null;
    }
    const parsed = moment(date);
    if (!parsed.isValid()) {
        return null;
    }
    return parsed.format("MM/DD/YYYY");
}


// Utility function to parse MM/DD/YYYY string to Date object
export function parseDate(dateStr: string | undefined): Date | null {
    if (!dateStr) return null;
    const [month, day, year] = dateStr?.split("/").map(Number);
    if (!month || !day || !year) return null;
    const date = new Date(year, month - 1, day); // Month is 0-based in Date
    return isNaN(date.getTime()) ? null : date;
}